module.exports = __webpack_public_path__ + "static/img/step-112.697165b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tutorial/sery/step-112.png
// module id = V7SG
// module chunks = 1